import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import api from '../../services/api';
import { money } from '../purchase-orders/poLine';

const Stat = ({ label, value, testid }) => (
  <Card><CardContent className="pt-4"><p className="text-xs text-slate-500">{label}</p><p className="text-2xl font-bold" data-testid={testid}>{value}</p></CardContent></Card>
);

const Breakdown = ({ title, rows }) => (
  <Card><CardHeader className="pb-2"><CardTitle className="text-base">{title}</CardTitle></CardHeader><CardContent>
    <table className="w-full text-sm"><tbody>
      {rows.length === 0 && <tr><td className="text-slate-500 py-2">No data</td></tr>}
      {rows.map((r) => <tr key={r.name} className="border-t"><td className="py-1">{r.name}</td><td className="py-1 text-slate-500">{r.items} item{r.items === 1 ? '' : 's'}</td><td className="py-1 text-right font-medium">{money(r.value)}</td></tr>)}
    </tbody></table>
  </CardContent></Card>
);

export default function ReportsTab() {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/general-inventory/reports/summary', { params: { days } }).then((r) => setD(r.data)); }, [days]);
  if (!d) { return <p className="text-slate-500 p-4">Loading…</p>; }
  return (
    <div className="space-y-4" data-testid="gi-reports-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Stock value (at avg cost)" value={money(d.total_value)} testid="rep-total-value" />
        <Stat label="Items" value={d.item_count} testid="rep-items" />
        <Stat label="Low stock" value={d.low_stock} testid="rep-low" />
        <Stat label="On order (value)" value={money(d.on_order_value)} testid="rep-on-order" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Breakdown title="Value by category" rows={d.by_category} />
        <Breakdown title="Value by location" rows={d.by_location} />
      </div>
      <Card><CardHeader className="pb-2 flex flex-row items-center justify-between">
        <CardTitle className="text-base">Usage & wastage</CardTitle>
        <select className="border rounded-md h-9 px-2 text-sm" value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="rep-days">
          {[7, 30, 90, 365].map((n) => <option key={n} value={n}>Last {n} days</option>)}
        </select>
      </CardHeader><CardContent>
        <table className="w-full text-sm"><thead className="bg-slate-100"><tr>{['Item', 'Used / sold', 'Wastage', 'Cost'].map((h) => <th key={h} className="text-left px-2 py-1">{h}</th>)}</tr></thead>
          <tbody>
            {d.usage.length === 0 && <tr><td colSpan={4} className="text-center py-4 text-slate-500">No usage recorded in this period — record it with Adjust stock (Used, Sold, Wastage).</td></tr>}
            {d.usage.map((u) => <tr key={u.item_id} className="border-t"><td className="px-2 py-1">{u.name}</td><td className="px-2 py-1">{u.used}</td><td className="px-2 py-1 text-red-600">{u.wastage || '—'}</td><td className="px-2 py-1">{money(u.cost)}</td></tr>)}
          </tbody></table>
      </CardContent></Card>
    </div>
  );
}
